import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const PlanContainer = styled.div`
  //width: calc(90%);
  height: 100%;
  border: 1px solid ${Variables.colors.complementary_400};
  border-radius: 12px;
  box-shadow: 0 2px 4px 0 #898989;
  max-height: 600px;
  pointer-events: ${props => (props.disabled ? "none" : "")};
  transition: 0.15s;
  &:hover {
    transform: scale(1.02);
  }
`;

export const Header = styled.div`
  background-color: ${props =>
    props.color ? props.color : Variables.colors.white};
  padding: 12px 8px 8px;
  border-radius: 12px 12px 0 0;
  height: 60px;
  text-align: center;
  font-size: ${Variables.font_sizes.x2_large};
  font-weight: ${Variables.font_weight.bold};
  color: ${props =>
    props.color ? Variables.colors.white : Variables.colors.black};
  .notice {
    font-size: ${Variables.font_sizes.small};
    margin-top: 8px;
    font-weight: ${Variables.font_weight.regular};
  }
`;

export const Body = styled.ul`
  padding: 9px 8px;
  height: ${props =>
    props.showTraial
      ? "calc(100% - 60px - 190px) "
      : "calc(100% - 60px - 170px) "};
  overflow-y: auto;
  margin: 0;
  position: relative;
  .feature-item {
    position: relative;
    font-size: ${Variables.font_sizes.medium};
    margin-bottom: 10px;
    color: ${Variables.colors.complementary_700};
    padding-right: 14px;
    &:before {
      content: "–";
      position: absolute;
      margin-right: -12px;
      margin-top: 3px;
    }
    &.first-item {
      color: ${Variables.colors.complementary_800};
      font-weight: ${Variables.font_weight.bold};
      padding-right: 10px !important;
      margin-bottom: 12px;
      &:before {
        content: "";
      }
    }
  }
  list-style-type: none;
  .extra-info {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.tertiary_800};
    margin-top: 32px;
    line-height: 1.4;
    a {
      color: ${Variables.colors.tertiary_700};
      text-decoration: underline;
    }
  }
`;

export const Footer = styled.div`
  padding: 14px 8px 8px;
  border-top: 1px solid ${Variables.colors.complementary_400};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${props =>
    props.verticallyCenter ? "center" : "flex-start"};
  height: ${props => (props.showTraial ? "190px" : "170px")};
  .durations {
    display: flex;
    width: 100%;
    height: 78px;
  }
  .purchase-button {
    background-color: ${Variables.colors.primary_dark};
    color: ${Variables.colors.white};
    padding: 8px 16px;
    font-size: ${Variables.font_sizes.x1_medium};
    font-weight: ${Variables.font_weight.medium};
    text-align: center;
    border-radius: 12px;
    width: 80%;
    margin-top: 10px;
    pointer-events: inherit;
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 8px 0 #cccccc;
      opacity: 0.9;
    }
  }
  .footer-text {
    font-size: ${Variables.font_sizes.medium};
    color: ${props =>
      props.defaultFooterTextColor
        ? Variables.colors.complementary_800
        : Variables.colors.tertiary_800};
    font-weight: ${Variables.font_weight.medium};
    text-align: center;
    line-height: 1.6;
    padding: 0 16px;
    height: 78px;
    display: flex;
    align-items: center;
  }
  .gift-text {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.tertiary_800};
    text-decoration: underline;
    margin-top: 12px;
    font-weight: ${Variables.font_weight.medium};
    cursor: pointer;
  }
`;

export const DurationBox = styled.div`
  box-shadow: 0 2px 4px 0 #898989;
  border-radius: 12px;
  padding: 8px 12px;
  position: relative;
  text-align: center;
  border: ${props =>
    props.selected ? "3px solid " + Variables.colors.primary_dark : ""};
  font-size: ${Variables.font_sizes.medium};
  font-weight: ${Variables.font_weight.medium};
  color: ${Variables.colors.complementary_800};
  width: 47%;
  margin-left: 6%;
  &:last-child {
    margin-left: 0;
  }
  .text {
    margin-bottom: 4px;
  }
  .colored-text {
    color: ${Variables.colors.tertiary_700};
    font-size: ${Variables.font_sizes.x_small};
    text-decoration: line-through;
  }
  .discount {
    position: absolute;
    background-color: ${Variables.colors.red_450};
    color: ${Variables.colors.white};
    border-radius: 50%;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Dosis", Arial, Helvetica, sans-serif;
    right: calc((-32px + 6px) / 2);
    top: calc((-32px + 6px) / 2);
    font-size: ${Variables.font_sizes.small};
  }
  pointer-events: inherit;
  cursor: pointer;
  &:hover {
    box-shadow: 0 2px 8px 0 #898989;
    background-color: ${Variables.colors.complementary_50};
  }
`;
